import { arbitrum, mainnet, polygon } from "viem/chains";
import { invert } from "lodash-es";

export enum Token {
  AAVE = "AAVE",
  ACH = "ACH",
  ADA = "ADA",
  ALGO = "ALGO",
  ALI = "ALI",
  ALICE = "ALICE",
  ALPHA = "ALPHA",
  AMP = "AMP",
  AMPL = "AMPL",
  ANGLE = "ANGLE",
  APE = "APE",
  API3 = "API3",
  AR = "AR",
  ARB = "ARB",
  ARPA = "ARPA",
  ATOM = "ATOM",
  AUCTION = "AUCTION",
  AVAX = "AVAX",
  AXS = "AXS",
  BAL = "BAL",
  BAND = "BAND",
  BAT = "BAT",
  BCH = "BCH",
  BEYOND = "BEYOND",
  BICO = "BICO",
  BLUR = "BLUR",
  BNB = "BNB",
  BNT = "BNT",
  BOBA = "BOBA",
  BOND = "BOND",
  BTC = "BTC",
  BTRST = "BTRST",
  BUSD = "BUSD",
  CBETH = "CBETH",
  CEL = "CEL",
  CFG = "CFG",
  CHZ = "CHZ",
  COMP = "COMP",
  CRO = "CRO",
  CRV = "CRV",
  CTX = "CTX",
  CUBE = "CUBE",
  CUDOS = "CUDOS",
  DAI = "DAI",
  DFYN = "DFYN",
  DOGE = "DOGE",
  DOT = "DOT",
  DPI = "DPI",
  DYDX = "DYDX",
  ELON = "ELON",
  ENJ = "ENJ",
  ENS = "ENS",
  EOS = "EOS",
  ETH = "ETH",
  ETHW = "ETHW",
  EXRD = "EXRD",
  FET = "FET",
  FIDA = "FIDA",
  FIL = "FIL",
  FLOKI = "FLOKI",
  FLOW = "FLOW",
  FTM = "FTM",
  FTT = "FTT",
  GALA = "GALA",
  GALA_OLD = "GALA_OLD",
  GALA_V1 = "GALAv1",
  GMX = "GMX",
  GODS = "GODS",
  GRT = "GRT",
  GT = "GT",
  HBAR = "HBAR",
  HFT = "HFT",
  HMT = "HMT",
  ICP = "ICP",
  ICX = "ICX",
  IMX = "IMX",
  INDEX = "INDEX",
  IOST = "IOST",
  IOTX = "IOTX",
  JUP = "JUP",
  KAVA = "KAVA",
  KIN = "KIN",
  KNC = "KNC",
  KP3R = "KP3R",
  KSM = "KSM",
  LCX = "LCX",
  LDO = "LDO",
  LINK = "LINK",
  LOOT = "LOOT",
  LPT = "LPT",
  LRC = "LRC",
  MAGIC = "MAGIC",
  MANA = "MANA",
  MATIC = "MATIC",
  MCO2 = "MCO2",
  MDX = "MDX",
  MINA = "MINA",
  MIR = "MIR",
  MKR = "MKR",
  MNGO = "MNGO",
  MPL = "MPL",
  MULTI = "MULTI",
  NEAR = "NEAR",
  NEO = "NEO",
  NEXO = "NEXO",
  NYM = "NYM",
  OCEAN = "OCEAN",
  OMG = "OMG",
  ONE = "ONE",
  PAX = "PAX",
  PERP = "PERP",
  PEPE = "PEPE",
  PLA = "PLA",
  PNG = "PNG",
  GUSD = "GUSD",
  POLS = "POLS",
  PRIMATE = "PRIMATE",
  PSP = "PSP",
  PSTAKE = "PSTAKE",
  PUSH = "PUSH",
  QNT = "QNT",
  QRDO = "QRDO",
  QTUM = "QTUM",
  RAD = "RAD",
  RADAR = "RADAR",
  RAY = "RAY",
  RDNT = "RDNT",
  REN = "REN",
  RENBTC = "RENBTC",
  REQ = "REQ",
  RLC = "RLC",
  RLY = "RLY",
  ROSE = "ROSE",
  ROUTE = "ROUTE",
  RSR = "RSR",
  RUNE = "RUNE",
  RVN = "RVN",
  SAND = "SAND",
  SCY = "SCY",
  SD = "SD",
  SGB = "SGB",
  SHIB = "SHIB",
  SKL = "SKL",
  SNX = "SNX",
  SOL = "SOL",
  SRM = "SRM",
  STX = "STX",
  SUSHI = "SUSHI",
  THETA = "THETA",
  TRAC = "TRAC",
  TRX = "TRX",
  TUSD = "TUSD",
  UMEE = "UMEE",
  UNI = "UNI",
  USDC = "USDC",
  USDP = "USDP",
  USDT = "USDT",
  UST = "UST",
  USTC = "USTC",
  VET = "VET",
  VGX = "VGX",
  WAMPL = "WAMPL",
  WAVES = "WAVES",
  WBTC = "WBTC",
  WETH = "WETH",
  WMATIC = "WMATIC",
  XDC = "XDC",
  XLM = "XLM",
  XTZ = "XTZ",
  YFI = "YFI",
  YGG = "YGG",
  ZIL = "ZIL",
  ZKP = "ZKP",
  ZRX = "ZRX",
  "1INCH" = "1INCH",
}

export const ETH_TOKEN_ADDRESSES: Partial<Record<Token, `0x${string}`>> = {
  WBTC: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
  AAVE: "0x7Fc66500c84A76Ad7e9c93437bFc5Ac33E2DDaE9",
  CEL: "0xaaAEBE6Fe48E54f431b0C390CfaF0b017d09D42d",
  // CUBE: "0x622dFfCc4e83C64ba959530A5a5580687a57581b",
  DPI: "0x1494CA1F11D487c2bBe4543E90080AeBa4BA3C2b",
  FTM: "0x4E15361FD6b4BB609Fa63C81A2be19d873717870",
  USDP: "0x8E870D67F660D95d5be530380D0eC0bd388289E1",
  RENBTC: "0xEB4C2781e4ebA804CE9a9803C67d0893436bB27D",
  YGG: "0x25f8087EAD173b73D6e8B84329989A8eEA16CF73",
  TUSD: "0x0000000000085d4780B73119b644AE5ecd22b376",
  SAND: "0x3845badAde8e6dFF049820680d1F14bD3903a5d0",
  DAI: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
  WETH: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
  USDC: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
  LINK: "0x514910771AF9Ca656af840dff83E8264EcF986CA",
  MKR: "0x9f8F72aA9304c8B593d555F12eF6589cC3A579A2",
  SUSHI: "0x6B3595068778DD592e39A122f4f5a5cF09C90fE2",
  SHIB: "0x95aD61b0a150d79219dCF64E1E6Cc01f0B64C4cE",
  BAND: "0xBA11D00c5f74255f56a5E366F4F77f5A186d7f55",
  COMP: "0xc00e94Cb662C3520282E6f5717214004A7f26888",
  MATIC: "0x7D1AfA7B718fb893dB30A3aBc0Cfc608AaCfeBB0",
  YFI: "0x0bc529c00C6401aEF6D220BE8C6Ea1667F6Ad93e",
  CRV: "0xD533a949740bb3306d119CC777fa900bA034cd52",
  HFT: "0xb3999F658C0391d94A37f7FF328F3feC942BcADC",
  UNI: "0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984",
  "1INCH": "0x111111111117dC0aa78b770fA6A738034120C302",
  BUSD: "0x4Fabb145d64652a948d72533023f6E7A623C7C53",
  APE: "0x4d224452801ACEd8B2F0aebE155379bb5D594381",
  ZRX: "0xE41d2489571d322189246DaFA5ebDe1F4699F498",
  BAL: "0xba100000625a3754423978a60c9317c58a424e3D",
  GRT: "0xc944E90C64B2c07662A292be6244BDf05Cda44a7",
  OMG: "0xd26114cd6EE289AccF82350c8d8487fedB8A0C07",
  CRO: "0xA0b73E1Ff0B80914AB6fe0444E65848C4C34450b",
  FTT: "0x50D1c9771902476076eCFc8B2A83Ad6b9355a4c9",
  BAT: "0x0D8775F648430679A709E98d2b0Cb6250d2887EF",
  AMP: "0xfF20817765cB7f73d4bde2e66e067E58D11095C2",
  REN: "0x408e41876cCCDC0F92210600ef50372656052a38",
  PERP: "0xbC396689893D065F41bc2C6EcbeE5e0085233447",
  MULTI: "0x65Ef703f5594D2573eb71Aaf55BC0CB548492df4",
  MPL: "0x33349B282065b0284d756F0577FB39c158F935e6",
  GALA: "0x15D4c048F83bd7e37d49eA4C83a07267Ec4203dA",
  ENS: "0xC18360217D8F7Ab5e7c516566761Ea12Ce7F9D72",
  LDO: "0x5A98FcBEA516Cf06857215779Fd812CA3beF1B32",
  IMX: "0xF57e7e7C23978C3cAEC3C3548E3D615c346e79fF",
  USDT: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
  DYDX: "0x92D6C1e31e14520e676a687F0a93788B716BEff5",
  CBETH: "0xBe9895146f7AF43049ca1c1AE358B0541Ea49704",
  CTX: "0x321C2fE4446C7c963dc41Dd58879AF648838f98D",
  BLUR: "0x5283D291DBCF85356A21bA090E6db59121208b44",
  FET: "0xaea46A60368A7bD060eec7DF8CBa43b7EF41Ad85",
  ETH: "0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE",
};

export const ETH_TOKEN_ADDRESSES_TO_SYMBOL_MAP: Record<string, string> =
  invert(ETH_TOKEN_ADDRESSES);
export const POLYGON_TOKENS_ADDRESSES: Partial<Record<Token, `0x${string}`>> = {
  WETH: "0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619",
  WMATIC: "0x0d500B1d8E8eF31E21C99d1Db9A6444d3ADf1270",
  WBTC: "0x1BFD67037B42Cf73acF2047067bd4F2C47D9BfD6",
  USDC: "0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174",
  USDT: "0xc2132D05D31c914a87C6611C10748AEb04B58e8F",
  DAI: "0x8f3Cf7ad23Cd3CaDbD9735AFf958023239c6A063",
  BAL: "0x9a71012B13CA4d3D0Cdc72A177DF3ef03b0E76A3",
  LINK: "0x53E0bca35eC356BD5ddDFebbD1Fc0fD03FaBad39",
  AAVE: "0xD6DF932A45C0f255f85145f286eA0b292B21C90B",
  CRV: "0x172370d5Cd63279eFa6d502DAB29171933a610AF",
  MKR: "0x6f7C932e7684666C9fd1d44527765433e01fF61d",
  MATIC: "0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE",
};

export const POLYGON_TOKEN_ADDRESSES_TO_SYMBOL_MAP: Record<`0x${string}`, string> =
  invert(POLYGON_TOKENS_ADDRESSES);
export const ARBITRUM_TOKENS_ADDRESSES: Partial<Record<Token, `0x${string}`>> = {
  DAI: "0xDA10009cBd5D07dd0CeCc66161FC93D7c9000da1",
  GMX: "0xfc5A1A6EB076a2C7aD06eD22C90d7E710E35ad0a",
  MAGIC: "0x2c852D3334188BE136bFC540EF2bB8C37b590BAD",
  RDNT: "0x3082CC23568eA640225c2467653dB90e9250AaA0",
  USDC: "0xFF970A61A04b1cA14834A43f5dE4533eBDDB5CC8",
  USDT: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
  WBTC: "0x2f2a2543B76A4166549F7aaB2e75Bef0aefC5B0f",
  WETH: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
};

export const ARBITRUM_TOKEN_ADDRESSES_TO_SYMBOL_MAP: Record<`0x${string}`, string> =
  invert(ARBITRUM_TOKENS_ADDRESSES);
export const TOKEN_NAMES: Partial<Record<Token, string>> = {
  [Token["1INCH"]]: "1inch Network",
  [Token.AAVE]: "Aave",
  [Token.AMP]: "AMP",
  [Token.APE]: "ApeCoin",
  [Token.ARB]: "Arbitrum",
  [Token.BAL]: "Balancer",
  [Token.BAND]: "Band Protocol",
  [Token.BAT]: "Basic Attention Token",
  [Token.BLUR]: "Blur",
  [Token.BUSD]: "Binance USD",
  [Token.CBETH]: "Coinbase Wrapped Staked ETH",
  [Token.CEL]: "Celsius",
  [Token.COMP]: "Compound",
  [Token.CRO]: "Cronos",
  [Token.CRV]: "Curve DAO",
  [Token.CTX]: "Cryptex",
  [Token.DAI]: "Dai",
  [Token.DYDX]: "dYdX",
  [Token.ENS]: "Ethereum Name Service",
  [Token.ETH]: "Ethereum",
  [Token.FET]: "Fetch",
  [Token.FTM]: "Fantom",
  [Token.FTT]: "FTX Token",
  [Token.GALA]: "Gala",
  [Token.GMX]: "GMX",
  [Token.GRT]: "The Graph",
  [Token.GUSD]: "Gemini Dollar",
  [Token.HFT]: "Hashflow",
  [Token.IMX]: "Immutable X",
  [Token.LDO]: "Lido DAO",
  [Token.LINK]: "ChainLink",
  [Token.MAGIC]: "MAGICToken",
  [Token.MATIC]: "Polygon",
  [Token.MKR]: "Maker",
  [Token.OMG]: "OMG Network",
  [Token.PAX]: "Pax Dollar",
  [Token.PERP]: "Perpetual Protocol",
  [Token.RDNT]: "Radiant",
  [Token.REN]: "Ren",
  [Token.RENBTC]: "Ren BTC",
  [Token.SAND]: "The Sandbox",
  [Token.SHIB]: "Shiba Inu",
  [Token.SUSHI]: "SushiToken",
  [Token.TUSD]: "True USD",
  [Token.UNI]: "Uniswap",
  [Token.USDC]: "USD Coin",
  [Token.USDP]: "Pax Dollar",
  [Token.USDT]: "Tether",
  [Token.UST]: "US Tether",
  [Token.USTC]: "Wrapped USTC",
  [Token.WBTC]: "Wrapped Bitcoin",
  [Token.WETH]: "Wrapped Ethereum",
  [Token.WMATIC]: "Wrapped Matic",
  [Token.YFI]: "yearn.finance",
  [Token.ZRX]: "0x",
};

export const BEBOP_CONTRACT = "0xBeB09000fa59627dc02Bb55448AC1893EAa501A5";
export const BEBOP_ETH_POLY_MAKER_ADDRESS = "0x77DBFa9A969dBadac6e3D938c2668c655E341aB0";
export const ARB_MAKER_ADDRESS = "0x0087BB802D9C0e343F00510000729031ce00bf27";

export const WRAPPED_ABI = [
  {
    constant: true,
    inputs: [],
    name: "name",
    outputs: [{ name: "", type: "string" }],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
  {
    constant: false,
    inputs: [
      { name: "guy", type: "address" },
      { name: "wad", type: "uint256" },
    ],
    name: "approve",
    outputs: [{ name: "", type: "bool" }],
    payable: false,
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    constant: true,
    inputs: [],
    name: "totalSupply",
    outputs: [{ name: "", type: "uint256" }],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
  {
    constant: false,
    inputs: [
      { name: "src", type: "address" },
      { name: "dst", type: "address" },
      {
        name: "wad",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [{ name: "", type: "bool" }],
    payable: false,
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    constant: false,
    inputs: [{ name: "wad", type: "uint256" }],
    name: "withdraw",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    constant: true,
    inputs: [],
    name: "decimals",
    outputs: [{ name: "", type: "uint8" }],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
  {
    constant: true,
    inputs: [{ name: "", type: "address" }],
    name: "balanceOf",
    outputs: [{ name: "", type: "uint256" }],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
  {
    constant: true,
    inputs: [],
    name: "symbol",
    outputs: [{ name: "", type: "string" }],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
  {
    constant: false,
    inputs: [
      { name: "dst", type: "address" },
      { name: "wad", type: "uint256" },
    ],
    name: "transfer",
    outputs: [{ name: "", type: "bool" }],
    payable: false,
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    constant: false,
    inputs: [],
    name: "deposit",
    outputs: [],
    payable: true,
    stateMutability: "payable",
    type: "function",
  },
  {
    constant: true,
    inputs: [
      { name: "", type: "address" },
      { name: "", type: "address" },
    ],
    name: "allowance",
    outputs: [{ name: "", type: "uint256" }],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
  { payable: true, stateMutability: "payable", type: "fallback" },
  {
    anonymous: false,
    inputs: [
      { indexed: true, name: "src", type: "address" },
      {
        indexed: true,
        name: "guy",
        type: "address",
      },
      { indexed: false, name: "wad", type: "uint256" },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, name: "src", type: "address" },
      {
        indexed: true,
        name: "dst",
        type: "address",
      },
      { indexed: false, name: "wad", type: "uint256" },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, name: "dst", type: "address" },
      {
        indexed: false,
        name: "wad",
        type: "uint256",
      },
    ],
    name: "Deposit",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, name: "src", type: "address" },
      {
        indexed: false,
        name: "wad",
        type: "uint256",
      },
    ],
    name: "Withdrawal",
    type: "event",
  },
] as const;

export const NETWORK_TO_TOKEN_ADDRESS_MAP: Record<number, Record<string, `0x${string}`>> = {
  [mainnet.id]: ETH_TOKEN_ADDRESSES,
  [polygon.id]: POLYGON_TOKENS_ADDRESSES,
  [arbitrum.id]: ARBITRUM_TOKENS_ADDRESSES,
};
export const NETWORK_TO_TOKEN_SYMBOL_MAP: Record<number, Record<string, string>> = {
  [mainnet.id]: ETH_TOKEN_ADDRESSES_TO_SYMBOL_MAP,
  [polygon.id]: POLYGON_TOKEN_ADDRESSES_TO_SYMBOL_MAP,
  [arbitrum.id]: ARBITRUM_TOKEN_ADDRESSES_TO_SYMBOL_MAP,
};

export const NETWORK_TO_BEBOP_CONTRACT_ADDRESS_MAP: Record<number, `0x${string}`> = {
  [mainnet.id]: BEBOP_CONTRACT,
  [polygon.id]: BEBOP_CONTRACT,
  [arbitrum.id]: BEBOP_CONTRACT,
};
export const NETWORK_TO_MAKER_CONTRACT_ADDRESS_MAP: Record<number, string> = {
  [mainnet.id]: BEBOP_ETH_POLY_MAKER_ADDRESS,
  [polygon.id]: BEBOP_ETH_POLY_MAKER_ADDRESS,
  [arbitrum.id]: ARB_MAKER_ADDRESS,
};

/**
 * Some tokens require a revoke before the increasing allowances/approvals
 */
export const REVOKE_BEFORE_APPROVAL_REQUIRED = [Token.CRV, Token.LDO];
